import { Box } from "@mui/material"
import dayjs, { Dayjs } from "dayjs"
import { Ref, forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { Constants } from "../../../../utils/constants"
import { toUnitTimeZone } from "../../../../utils/methods/calcDate"
import { DateModalSimple } from "../simple"

/* import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Activar los plugins
dayjs.extend(utc);
dayjs.extend(timezone); */

const useStyles = () => {
    return {
        container: {
            display: 'flex',
            gap: '20px'
        }
    }
}
type DateModalRangeProps = {
    from?: Dayjs | null;
    to?: Dayjs | null;
    clear?: boolean;
    setDate?: (payload: { target: { name: string; value: Dayjs | null } }) => void
    defaultErrors?: {
        to: string;
        from: string;
    }
    mimTimeZone?: {
        code: string;
        value: number;
    }
    maxToDay?: Dayjs | null;
    titleFrom?:string;
    titleTo?:string;
    minHeight?:number
    disable?: boolean
}
type DateModalRangeRef = {
    getRange: () => { from?: Dayjs | null; to?: Dayjs | null }
    updateRange: (payload: { from?: Dayjs | null; to?: Dayjs | null }) => void
}
const DateModalRange = forwardRef((props: DateModalRangeProps, ref: Ref<DateModalRangeRef>) => {
    const styles = useStyles()
    const [defaulValues, setDefaultValues] = useState<{ from?: Dayjs | null; to?: Dayjs | null }>({ from: dayjs(props.from), })
    const [errors, setErrors] = useState({ to: false, from: false })
    const [isToBiggerThanFrom, setIsToBiggerThanFrom] = useState(dayjs(defaulValues.to).date() > dayjs(defaulValues.from).date())
    const formatInitialDate = dayjs(toUnitTimeZone(new Date(), props?.mimTimeZone?.value ?? Constants.defaultTimeZoneObject.value,))
    const getDate = (date: Dayjs, name: 'to' | 'from') => {
        setErrors(prev => ({ ...prev, [name]: false }))
        const originalDate = dayjs(date)
        const newDate = originalDate.second(0).millisecond(0) //Para eliminar los segundos
        if (props.setDate) {
            props.setDate({ target: { name, value: newDate } })
        }
        setDefaultValues(prev => ({ ...prev, [name]: newDate }))
    }

    const clearDate = (name: 'to' | 'from') => {
        setErrors(prev => ({ ...prev, [name]: false }))
        if (props.setDate) {
            props.setDate({ target: { name, value: null } })
        }
        setDefaultValues(prev => ({ ...prev, [name]: null }))
    } 

    useImperativeHandle(ref, () => ({
        getRange: () => {
            setErrors(prev => ({ ...prev, from: !defaulValues.from, to: !defaulValues.to }))
            return defaulValues
        },
        updateRange: (payload) => {
            setDefaultValues(payload)
        }
    }))

    useEffect(() => {
        setDefaultValues({
            to: props.to, from: props.from
        })

    }, [props.to, props.from])
    return (
        <Box sx={styles.container}>
            <DateModalSimple
                timeZone={props?.mimTimeZone?.code ?? Constants.defaultTimeZone}
                setIsToBiggerThanFrom={setIsToBiggerThanFrom}
                buttonTitle={props.titleFrom ? props.titleFrom : "Desde *"}
                errorMsg={props?.defaultErrors?.from}
                defaultDate={defaulValues.from}
                error={!!(props?.defaultErrors?.from ?? errors.from)}
                getDate={(date) => { getDate(date, 'from') }}
                clearDate={() => { clearDate('from') }}
                clear={props.clear}
                payload={{
                    max: defaulValues.to,
                    min: formatInitialDate,
                    is: { start: true, startLower: isToBiggerThanFrom }
                }}
                minHeight={props.minHeight}
                disable={props.disable}
                title='SELECCIÓN DE FECHA DE INICIO' name="from" />

            <DateModalSimple
                timeZone={props?.mimTimeZone?.code ?? Constants.defaultTimeZone}
                setIsToBiggerThanFrom={setIsToBiggerThanFrom}
                buttonTitle={props.titleTo ? props.titleTo : "Hasta *"}
                errorMsg={props?.defaultErrors?.to}
                defaultDate={defaulValues.to}
                error={!!(props?.defaultErrors?.to ?? errors.to)}
                getDate={(date) => { getDate(date, 'to') }}
                clearDate={() => { clearDate('to') }}
                clear={props.clear}
                payload={{
                    max: props.maxToDay ? props.maxToDay : null,
                    min: defaulValues.from ?? dayjs(toUnitTimeZone(new Date(), props?.mimTimeZone?.value ?? Constants.defaultTimeZoneObject.value,)),
                    is: { end: true, endBigger: isToBiggerThanFrom }
                }}
                minHeight={props.minHeight}
                disable={props.disable}
                title='SELECCIÓN DE FECHA DE FIN' name="to"
            />
        </Box>
    )
})

export { DateModalRange }
export type { DateModalRangeRef }

